
export const checkDigit = (gtin:string) => 
  {
      let position_number:number = 17;
      let message:string = '';
      let error:boolean = false;

      if(gtin !== '')
      {
          //utilizado 14 porque é o número máximo de carateres que a GS1 trabalha
          if(gtin.length <= 14)
          {
              let position_value = [3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3]; //matriz base de cálculo (https://www.gs1.org/services/how-calculate-check-digit-manually)
              let gtin_total = 0;
              let gtin_positions = gtin.split("").slice(0,-1); //retira o último dígito do gtin informado (verificador)
              let add_zero = position_number - gtin.length+1; //adiciona um campo a mais para substituir o campo retirado
              let multiple_10 = 0;

              if(add_zero < position_number)
              {
                  for (let i = 0; i < add_zero; i++) 
                  {
                      gtin_positions.unshift('0');
                  }
              }

              for (let i = 0; i < position_number; i++) 
              {
              gtin_total = gtin_total + (position_value[i] * parseInt(gtin_positions[i])); 
              }

              if(gtin_total === Math.ceil((gtin_total)/10)*10)
              {
              multiple_10 = gtin_total;
              }
              else
              {
              multiple_10 = Math.ceil((gtin_total+1)/10)*10;
              }

              let check_digit = multiple_10 - gtin_total

              if(check_digit !== parseInt(gtin.substring(gtin.length-1)))
              {
              error = true;
              message = `Dígito verificador incorreto. O número correto é ${gtin.slice(0,-1)}${check_digit}?`
              }
              
          }
      else
      {
          error = true;
          message = `O gtin informado ${gtin} não pode ser maior que 14 dígitos.`;
      }
  }
  else
  {
    error = true;
    message = `Número do código de barras (GTIN) não encontrado.`;
  }
  
  return{
    error: error,
    message: message
  }
}


export const validateGtin = (gtin:string) =>
{
  let message:string = '';
  let error:boolean = false;

  if(!/^[0-9]+$/.test(gtin))
  {
    error = true;
    message = `O número do código de barras (GTIN) deve conter apenas caracteres numéricos. Por favor, verifique se há erros de digitação.`;
  }
  else if(gtin.length < 8)
  {
    error = true;
    message = `O número do código de barras (GTIN) informado é curto, podem ter 8, 12, 13 ou 14 digitos. Por favor, verifique se há erros de digitação.`;
  }
  else if(gtin.substring(0, 3) === '000')
  {
    error = true;
    message = `O numero informado não é um código de barras (GTIN) válido. Por favor, verifique se há erros de digitação.`;
  }
  else
  {
    let verify_digit = checkDigit(gtin);
    error = verify_digit.error;
    message = verify_digit.message;
  }
  

  return {
    error: error,
    message: message
  }
}



